// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"291":"5f385cd5","641":"8395534f"}[chunkId] + ".css";
};